import { Component } from '@angular/core';
import { SalesReportService } from '../sales-report.service';
import { HttpService } from 'src/app/service/http.service';
import { WeeklyBookingsData } from '../weekly-bookings-data';
import { ChartjsData } from 'src/app/chartjs-data';
import { ChartjsDataElement } from 'src/app/chartjs-data-element';

@Component({
  selector: 'app-sales-report-third-tab',
  templateUrl: './sales-report-third-tab.component.html',
  styleUrls: ['./sales-report-third-tab.component.css']
})
export class SalesReportThirdTabComponent {

  immersionChartData: ChartjsData | null = null;
  immersionDurationChartData: ChartjsData | null = null;
  borderColors: string[] = ["rgb(0, 0, 255)","rgb(50, 205, 50)"];
  backgroundColor: string ="rgba(0,0,0,0.1)";

  immersionBookingData: WeeklyBookingsData[][] = [];

  constructor(
    public salesReportService: SalesReportService,
    private httpService: HttpService
  ){
    this.httpService.getWeeklyBookingsForImmersion().subscribe(res => {
      this.immersionBookingData = res;
      let dataLength = 0;
      let count = 1;
      let datasets: ChartjsDataElement[] = [];
      for(let data of res){
        if(data.length > dataLength){
          dataLength = data.length;
        }
        const dataElement: ChartjsDataElement = {
          label: data[0].year.toString(),
          data: [],
          fill: true,
          borderColor: this.borderColors[count-1],
          tension: 0.1,
          backgroundColor: [this.backgroundColor, this.backgroundColor]
        }
        for(let i = 0; i < data.length; i++){
          let bookingNum: number;
          if(i==0){
            bookingNum = data[i].bookings.length;
          } else {
            bookingNum = dataElement.data[i-1] + data[i].bookings.length;
          }
          dataElement.data.push(bookingNum);
        }
        count++;
        datasets.push(dataElement);
      }

      let labels: string[] = [];
      for(let i = 0; i<dataLength; i++){
        labels.push((i+1).toString());
      }
      this.immersionChartData = {
        labels: labels,
        datasets: datasets
      }
      this.updateDurationData(res, labels);
    });
  }

  updateDurationData(data: WeeklyBookingsData[][], labels: string[]){
    const thisYearData = data[0];
    const lastYearData = data[1];
    let count: number = 1;
    let datasets: ChartjsDataElement[] = [];
    const dataElement: ChartjsDataElement = {
      label: "2024",
      data: [],
      fill: true,
      borderColor: this.borderColors[count-1],
      tension: 0.1,
      backgroundColor: [this.backgroundColor, this.backgroundColor]
    };
    datasets.push(dataElement);
    let cumulatedDuration = 0;
    for(let data of thisYearData){
      cumulatedDuration += data.duration;
      dataElement.data.push(cumulatedDuration);
    }

    const dataElementLastYear: ChartjsDataElement = {
      label: "2023",
      data: [],
      fill: true,
      borderColor: this.borderColors[count],
      tension: 0.1,
      backgroundColor: [this.backgroundColor, this.backgroundColor]
    };
    let cumulatedDurationLastYear = 0;
    for(let data of lastYearData){
      cumulatedDurationLastYear += data.duration;
      dataElementLastYear.data.push(cumulatedDurationLastYear);
    }
    datasets.push(dataElementLastYear);
    this.immersionDurationChartData = {
      labels: labels,
      datasets: datasets
    };
  }
  

}
